module.exports = __webpack_public_path__ + "img/opinstallTips@3x.aeff22f3.png";